export const defaultSettings = {
  appVersion: '',
  webAppUrl: '',
  sentryEnvironment: '',
  userManager: {
    authority: '',
    client_id: '',
    response_type: '',
    scope: '',
  },
};

export const errorSettings = {
  appVersion: 'ERROR',
  webAppUrl: '',
  sentryEnvironment: '',
  userManager: {
    authority: '',
    client_id: '',
    response_type: '',
    scope: '',
  },
};

export type AppSettings = typeof defaultSettings;
